import { requestSharedAppReload, type SharedAppReloadReason } from "../../../../../../shared/frontend/system/appReloadCoordinator";

const RANDOM_ID_RADIX = 36;
/** Länge des Präfixes "0." einer Zufallszahl in Textform. */
const RANDOM_ID_PREFIX_LENGTH = 2;

export type AppReloadReason = SharedAppReloadReason;

type AppReloadRequest = {
  reason: AppReloadReason;
  dedupeKey?: string | null;
  delayMs?: number;
  sessionStorageKey?: string;
  sessionStorageValue?: string;
};

export const APP_RELOAD_REQUESTED_EVENT = "m1studio-app-reload-requested";

/** Produktadapter: ein gemeinsamer Koordinator für Datenersatz und Versionswechsel. */
export function requestAppReload(req: AppReloadRequest): boolean {
  if (typeof window === "undefined") return false;
  const accepted = requestSharedAppReload({ productKey: "m1member", ...req });
  if (!accepted) return false;
  try {
    window.dispatchEvent(new CustomEvent(APP_RELOAD_REQUESTED_EVENT, { detail: req }));
  } catch {
    // ignore
  }

  return true;
}

export function requestManualAppReload(reason: AppReloadReason = "manual"): void {
  if (typeof window === "undefined") return;
  requestAppReload({
    reason,
    dedupeKey: `manual:${Date.now()}:${Math.random().toString(RANDOM_ID_RADIX).slice(RANDOM_ID_PREFIX_LENGTH)}`
  });
}

